import { useEffect, useMemo, useState } from 'react';
import profileService from '../services/api/profileService';

/** @userstory US-COM-PUBPROF-11 */
const useTalentEmploymentTypes = (enabled = true) => {
	const [employmentTypes, setEmploymentTypes] = useState<string[]>(['Freelance']);
	const [isLoading, setIsLoading] = useState(enabled);

	useEffect(() => {
		let isMounted = true;

		if (!enabled) {
			setEmploymentTypes(['Freelance']);
			setIsLoading(false);
			return () => {
				isMounted = false;
			};
		}

		setIsLoading(true);
		profileService
			.getFreelanceProfile()
			.then((profile) => {
				if (!isMounted) return;
				setEmploymentTypes(
					profile.employmentTypes?.length ? profile.employmentTypes : ['Freelance'],
				);
			})
			.catch(() => {
				if (!isMounted) return;
				setEmploymentTypes(['Freelance']);
			})
			.finally(() => {
				if (isMounted) setIsLoading(false);
			});

		return () => {
			isMounted = false;
		};
	}, [enabled]);

	const normalizedEmploymentTypes = useMemo(
		() => employmentTypes.map((type) => type.toLowerCase()),
		[employmentTypes],
	);

	const hasFreelance = normalizedEmploymentTypes.includes('freelance');
	const hasEmployee = normalizedEmploymentTypes.includes('employee');

	return {
		employmentTypes,
		hasFreelance,
		hasEmployee,
		isEmployeeOnly: hasEmployee && !hasFreelance,
		isLoading,
	};
};

export default useTalentEmploymentTypes;
